'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _SortableListHeader = require('components/SortableListHeader/SortableListHeader');

var _SortableListHeader2 = _interopRequireDefault(_SortableListHeader);

var _statistics = require('helpers/statistics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoverageRecipientListHeader = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(CoverageRecipientListHeader, _PureComponent);

  function CoverageRecipientListHeader() {
    (0, _classCallCheck3.default)(this, CoverageRecipientListHeader);
    return (0, _possibleConstructorReturn3.default)(this, (CoverageRecipientListHeader.__proto__ || (0, _getPrototypeOf2.default)(CoverageRecipientListHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(CoverageRecipientListHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          order = _props.order,
          activeOrder = _props.activeOrder,
          onReorder = _props.onReorder,
          className = _props.className,
          columns = _props.columns;
      var t = this.context.t;


      return _react2.default.createElement(
        _ListItem2.default,
        { fullWidth: true, isTitle: true, className: (0, _bind2.default)(className) },
        columns.includes(_statistics.coverageRecipientsColumns.recipientId) && _react2.default.createElement(_SortableListHeader2.default, {
          title: t('ID'),
          name: 'recipientId',
          order: order,
          activeOrder: activeOrder,
          onReorder: onReorder
        }),
        columns.includes(_statistics.coverageRecipientsColumns.fullName) && _react2.default.createElement(_SortableListHeader2.default, {
          title: t('Name'),
          name: 'fullName',
          order: order,
          activeOrder: activeOrder,
          onReorder: onReorder
        }),
        columns.includes(_statistics.coverageRecipientsColumns.email) && _react2.default.createElement(_SortableListHeader2.default, {
          title: t('Email'),
          name: 'email',
          order: order,
          activeOrder: activeOrder,
          onReorder: onReorder
        }),
        columns.includes(_statistics.coverageRecipientsColumns.downloaded) && _react2.default.createElement(_SortableListHeader2.default, {
          title: t('Downloaded'),
          name: 'downloaded',
          order: order,
          activeOrder: activeOrder,
          onReorder: onReorder
        }),
        columns.includes(_statistics.coverageRecipientsColumns.expiryDate) && _react2.default.createElement(_SortableListHeader2.default, {
          title: t('Exp'),
          name: 'recepEd',
          order: order,
          activeOrder: activeOrder,
          onReorder: onReorder
        }),
        columns.includes(_statistics.coverageRecipientsColumns.details) && _react2.default.createElement('div', null),
        columns.includes(_statistics.coverageRecipientsColumns.info) && _react2.default.createElement('div', null),
        columns.includes(_statistics.coverageRecipientsColumns.share) && _react2.default.createElement('div', null)
      );
    }
  }]);
  return CoverageRecipientListHeader;
}(_react.PureComponent), _class.propTypes = {
  activeOrder: _propTypes2.default.string,
  className: _propTypes2.default.string,
  columns: _propTypes2.default.array,
  onReorder: _propTypes2.default.func,
  order: _propTypes2.default.object
}, _class.contextTypes = {
  onReorder: _noop3.default,
  t: _propTypes2.default.func
}, _class.defaultProps = {
  columns: []
}, _temp);
exports.default = CoverageRecipientListHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/CoverageRecipientsList/CoverageRecipientListHeader.js
// module id = 2110
// module chunks = 1